import { ConstantModel } from "@core/models/outros/constant.model";

export const FINANCIAL_PEOPLE_SITUATION: ConstantModel[] = [
  {
    id: 1,
    descricao: 'ATIVO',
    enum: '1',
  },
  {
    id: 2,
    descricao: 'INATIVO',
    enum: '2',
  },
  {
    id: 3,
    descricao: 'CADASTRANDO',
    enum: '3',
  },
  {
    id: 4,
    descricao: 'PRÉ-AGENDADO',
    enum: '4',
  },
  {
    id: 5,
    descricao: 'PRÉ-CADASTRO',
    enum: '5',
  },
  {
    id: 6,
    descricao: 'CONCLUIDO',
    enum: '6',
  },
  {
    id: 7,
    descricao: 'TRANSFERIDO',
    enum: '7',
  },
  {
    id: 8,
    descricao: 'DESISTENTE',
    enum: '8',
  },
]
